// export const API_BASE_URL = "http://127.0.0.1:8080"
export const API_BASE_URL =
  "https://asia-northeast3-aardvark-eng-deploy.cloudfunctions.net/aardvark_functions_dev";
export const OCR_GOOGLE_FUNCTION_URL =
  "https://asia-northeast3-aardvark-eng-deploy.cloudfunctions.net/ocr_image_to_text";
